<script setup>
import { useAccreditation } from '@/composables/useAccreditation'
import { useRoute } from 'vue-router'

// Module 13A (§9.8) — halaman publik TANPA login, diakses lewat signed URL
// (App\Http\Controllers\SelfAssessmentController::publicSummaryFrontendUrl()).
// meta.public SENGAJA true — router guard (plugins/1.router/guards.js)
// melewati SEMUA pengecekan auth/permission untuk halaman ini, sama seperti
// login.vue.
definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const route = useRoute('accreditation-self-assessment-result-id-public-summary')
const { fetchPublicSummary } = useAccreditation()

const summary = ref(null)
const error = ref('')
const loading = ref(true)

onMounted(async () => {
  try {
    summary.value = await fetchPublicSummary(route.params.resultId, route.query)
  } catch (e) {
    error.value = e?.status === 403
      ? 'Tautan ini tidak valid atau sudah kedaluwarsa.'
      : 'Gagal memuat rekap self-assessment.'
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="min-height: 100vh;"
  >
    <VCard
      max-width="640"
      class="ma-4"
      width="100%"
    >
      <VCardText class="pa-8">
        <h4 class="text-h4 font-weight-bold mb-1">
          Rekap Self-Assessment Akreditasi
        </h4>

        <VProgressLinear
          v-if="loading"
          indeterminate
          color="primary"
          class="my-4"
        />

        <VAlert
          v-else-if="error"
          type="error"
          variant="tonal"
        >
          {{ error }}
        </VAlert>

        <template v-else-if="summary">
          <p class="text-body-1 mb-1">
            <strong>{{ summary.unit }}</strong>
          </p>
          <p class="text-body-2 text-medium-emphasis mb-4">
            {{ summary.lpa }} — {{ summary.jenis_fasyankes }}
          </p>

          <ProgressGauge
            v-for="bab in summary.progress"
            :key="bab.node_id"
            :kode="bab.kode"
            :judul="bab.judul"
            :total-ep="bab.total_ep"
            :ep-terisi="bab.ep_terisi"
            :persentase="bab.persentase"
          />
        </template>
      </VCardText>
    </VCard>
  </div>
</template>
